/* Utility functions */

/**
 * Equalizes the height of a given group of elements, making them all
 * at least as big as the largest of the group (but not restricting future
 * expansion. You may optionally pass in a parent selector by which the
 * elements will be equalized (each instance of the group selector will be
 * given equal heights within thier parent, rather than across all elements
 * matching that selector globally).
 * @param string group
 * @param string parent
 */
exports.equalHeight = function (group, parent) {
    parent = parent || "body";
    jQuery(parent).each(function () {
        var tallest = 0;
        jQuery(this).find(group).each(function () {
            var $this = jQuery(this);

            var thisHeight = $this.height();
            if ($this.css('box-sizing') === 'content-box') {
                if (thisHeight > tallest) {
                    tallest = thisHeight;
                }
            } else {
                thisPadding = Number($this.css('padding-top').replace('px', ''))
                    + Number($this.css('padding-bottom').replace('px', ''));

                if ((thisHeight + thisPadding) > tallest) {
                    tallest = thisHeight + thisPadding;
                }
            }
        });
        jQuery(this).find(group).css('min-height', tallest);
    });
};

exports.trim = function (x) {
    return x.replace(/^\s+|\s+$/gm, '');
}

exports.ScrollToHash = function(hash, child, offset, speed) {
    offset = offset || 0;
    speed = speed || 800;

    if(hash.indexOf('/') >= 0) {
        hash = hash.split('/', 1)[0];
    }

    hash = encodeURIComponent(hash.replace('#', ''));

    var element = jQuery('[data-scroll="'+hash+'"]');

    if(child && jQuery(element).find(child).length > 0) {
        element = jQuery(element).find(child);
    }

    if(jQuery(element).length > 0) {
        if (!element.hasClass('recent-scroll')) {
            element.addClass('scroll-target').addClass('recent-scroll');
        }

        jQuery('html, body').animate({
            scrollTop: (
                element.offset().top - (200 + offset)
            )
        }, {
            complete: function() {
                setTimeout(function() {
                    element.removeClass('scroll-target');
                }, 500);

                setTimeout(function() {
                    element.removeClass('recent-scroll');
                }, 5000);
            }
        }, speed);
        return true;
    }

    return false;
}

exports.QueryStringToJSON = function() {
    var pairs = location.search.slice(1).split('&');

    var result = {};
    pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is true, trigger the function on the
// leading edge, instead of the trailing.
exports.debounce = function(wait, immediate, func) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};

exports.log = function() {
    if(Cookies.get("debug") == 1) {
        console.log(...arguments);
    }
}

function parse_query_string(query) {
    let vars = query.split("&");
    let query_string = {};
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        let key = decodeURIComponent(pair[0]);
        let value = decodeURIComponent(pair[1]);
        // If first entry with this name
        if (typeof query_string[key] === "undefined") {
            query_string[key] = decodeURIComponent(value);
            // If second entry with this name
        } else if (typeof query_string[key] === "string") {
            let arr = [query_string[key], decodeURIComponent(value)];
            query_string[key] = arr;
            // If third or later entry with this name
        } else {
            query_string[key].push(decodeURIComponent(value));
        }
    }
    return query_string;
}

exports.urlParam = function(name) {
    try {
        // Not supported in IE
        const params = new URLSearchParams(window.location.search);
        return params.get(name);
    } catch (e) {
        let params = parse_query_string(window.location.search.substring(1));
        return params[name] || null;
    }
}
